"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignFileNetInfoLabelInstance = exports.DesignFileNetInfoInstance = exports.DesignFileNetInfoSchema = exports.DesignFileNetInfoLabelSchema = void 0;
const zod_1 = require("zod");
const NetInfo_1 = require("./NetInfo");
const ProjectDataTypeInstance_1 = require("./ProjectInstances/ProjectDataTypeInstance");
exports.DesignFileNetInfoLabelSchema = zod_1.z.object({
    type: zod_1.z.string().default('unknown'),
    position: zod_1.z.tuple([zod_1.z.number(), zod_1.z.number()]),
    label: zod_1.z.string(),
    isGlobal: zod_1.z.boolean().optional(),
    isHierarchical: zod_1.z.boolean().optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).optional(),
});
exports.DesignFileNetInfoSchema = zod_1.z.preprocess((data) => {
    if (typeof data === 'object' && data !== null && 'localName' in data && !('localNames' in data)) {
        return {
            ...data,
            localNames: [data.localName],
        };
    }
    return data;
}, NetInfo_1.NetInfoSchema.extend({
    localName: zod_1.z.string().optional(),
    localNames: zod_1.z.string().array().optional(),
    netLabels: exports.DesignFileNetInfoLabelSchema.array().optional(),
}));
class DesignFileNetInfoInstance extends NetInfo_1.NetInfoInstance {
    constructor(context, opts) {
        super(context, opts);
        this.netLabels = [];
        if (opts.localName) {
            this.localName = this.netRefCtx.existingOrNewRef(opts.localName);
        }
        if (opts.netLabels) {
            this.netLabels = opts.netLabels.map((l) => new DesignFileNetInfoLabelInstance(context, l));
        }
    }
    toJSON() {
        return {
            ...super.toJSON(),
            localName: this.localName?.valueOf(),
            netLabels: this.netLabels?.map((l) => l.toJSON()),
        };
    }
    merge(other) {
        super.merge(other);
        return this;
    }
}
exports.DesignFileNetInfoInstance = DesignFileNetInfoInstance;
class DesignFileNetInfoLabelInstance extends ProjectDataTypeInstance_1.ProjectDataTypeInstance {
    constructor(context, opts) {
        super(context);
        this.position = opts.position;
        this.label = opts.label;
        this.isGlobal = opts.isGlobal;
        this.isHierarchical = opts.isHierarchical;
        this.metadata = opts.metadata;
        this.type = opts.type;
    }
    toJSON() {
        return {
            type: this.type,
            position: this.position,
            label: this.label.valueOf(),
            isGlobal: this.isGlobal,
            isHierarchical: this.isHierarchical,
            metadata: this.metadata,
        };
    }
}
exports.DesignFileNetInfoLabelInstance = DesignFileNetInfoLabelInstance;
//# sourceMappingURL=DesignFileNetInfo.js.map